import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pending-fill-disabled",
  "use": "icon-pending-fill-disabled-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-pending-fill-disabled\"><path fill=\"#000\" fill-opacity=\".25\" fill-rule=\"evenodd\" d=\"M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0m-6.267.033a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0m2.3.7a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m-5.3-.7a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol